import { render, staticRenderFns } from "./CompetencyProgress.vue?vue&type=template&id=6894ab5c&scoped=true&"
import script from "./CompetencyProgress.vue?vue&type=script&lang=js&"
export * from "./CompetencyProgress.vue?vue&type=script&lang=js&"
import style0 from "./CompetencyProgress.vue?vue&type=style&index=0&id=6894ab5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894ab5c",
  null
  
)

export default component.exports